import React from 'react';
import { ReactComponent as PoweredByLokk } from 'assets/logos/PoweredByLokk.svg'

const Footer = () => {
  return (
    <div className="h-full flex justify-center items-end">
      {/* <PoweredByLokk width="190" className="fill-black" /> */}
      <img
        className="w-[220px]"
        src="/valmarti.png"
        alt="valmarti"
      />
    </div>
  )
}

export default Footer;